export enum APIRequestResources {
    BuyUploadService = 'buy-sheet',
    CustomerService = 'customer',
    PcuUpdateService = 'pcu-update',
    PcuService = 'pcu',
    PlantsService = 'plants',
    OrderService = 'order',
    FinishGoodService = 'fg',
    ProductionPlantService = 'production',


    DepartmentService = 'department',
    EmployeeService = 'employee',
    WorkOrderService = 'work-order',
    DepartmentProcessService = 'department-process',
    WorkOrderProcessService = 'work-order-process',
    WorkOrderProcessTimeService = 'work-order-process-times',
}
